<template>
  <div v-if="video">
    <FeedbackMessage :feedback="feedback" :resetFeedback="resetFeedback" />

    <LoadingSpinner v-if="loading" message="Deleting video" />

    <AdminOnly class="flex justify-end mb-3">
      <AdminOptions
        v-if="!deleteClicked"
        @deleteClicked="deleteClicked = !deleteClicked"
        @editClicked="editClicked"
      />
      <div v-if="deleteClicked">
        <DeleteConfirmation
          @cancelDelete="deleteClicked = !deleteClicked"
          @deleteHandler="deleteHandler"
        />
      </div>
    </AdminOnly>
    <div class="grid lg:grid-cols-4 grid-cols-1 mb-10 gap-x-10 gap-y-5">
      <VimeoVideo class="lg:col-span-3" :link="video.link" :playVideo="true" />

      <div class="lg:text-left text-center flex flex-col h-5/6 w-full">
        <div class="my-auto">
          <p
            class="
              font-AvenirBlackFont
              text-gray-600
              md:text-2xl
              text-md
              uppercase
            "
          >
            {{ video.title }}
          </p>
          <p class="font-AvenirFont text-gray-600">{{ video.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AdminOnly from "../../AdminOnly.vue";
import DeleteConfirmation from "../../DeleteConfirmation.vue";
import AdminOptions from "../../AdminOptions.vue";
import LoadingSpinner from "../../LoadingSpinner.vue";
import FeedbackMessage from "../../FeedbackMessage.vue";
import VimeoVideo from "../../VimeoVideo.vue";

export default {
  name: "FeaturedVideo",

  props: {
    video: Object,
  },

  components: {
    AdminOnly,
    AdminOptions,
    DeleteConfirmation,
    LoadingSpinner,
    FeedbackMessage,
    VimeoVideo,
  },

  data() {
    return {
      deleteClicked: false,
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["feedback", "videosID"]),
  },

  methods: {
    ...mapActions(["deleteVideoFromS3", "resetFeedback"]),

    editClicked() {
      this.$router.push({
        name: "EditVideo",
        params: { id: this.video.id },
      });
    },

    async deleteHandler() {
      this.deleteClicked = false;
      this.loading = true;

      const { id: identifier, homeFeatured } = this.video;
      const { directoryKey: key } = this.videosID;

      await this.deleteVideoFromS3({ identifier, key, homeFeatured });

      this.$router.push({
        name: "Media",
      });

      this.loading = false;
    },
  },

  mounted() {
    this.$gtag.pageview({ page_title: this.video.title });
  },
};
</script>
